<template>
    <div class="global-container">
        <div class="second-header-wrap">
            <el-button @click="$router.back()" size="medium">返回</el-button>
            <template v-if="!fromOffline">
                <!--线上-->
                <el-button v-if="signupInfo.lineExamState == 0 && (groupType == 3 || groupType == 2 || groupType == 4)"
                           type="primary" @click="secondHanlder()" size="medium">网审二审
                </el-button>
                <el-button
                    v-if="signupInfo.lineExamState == 0 && groupType == 1 && state != 4 && state != 5 && state != 3"
                    @click="isShowReviewDialog = true" size="medium" type="primary">网审一审
                </el-button>
            </template>
            <template v-else>

                <!--线下-->
                <template v-if="checkIndexPermission(permission, '/staterunEnrolSystem/enrolStuAgainExamine')">
                    <template v-if="checkIndexPermission(permission, '/staterunEnrolSystem/enrolStuOneOfflineExamine')">
                        <el-button v-if="state != 3 && state != 8" @click="firstReview()" size="medium" type="primary">
                            线下一审
                        </el-button>
                    </template>
                    <template v-if="checkIndexPermission(permission, '/staterunEnrolSystem/enrolStuTwoOfflineExamine')">
                        <el-button v-if="state != 3 && state != 8" @click="examHandler()" size="medium" type="primary">
                            线下二审
                        </el-button>
                    </template>
                </template>
            </template>
            <el-button size="medium" type="primary" @click="signup"
                       v-if="state != 3 &&fromReserve && checkIndexPermission(permission, '/staterunEnrolSystem/enrolStuAdmitAndRemark')">
                录取
            </el-button>
            <template v-if="checkIndexPermission(permission, '/staterunEnrolSystem/enrolStuAdmitAndRemark')">
                <el-button @click="commentVisibility = true" size="medium" type="primary">备注
                </el-button>
            </template>

            <el-button @click="print()" type="primary" size="medium">打印</el-button>
        </div>
        <div class="content" id="content" ref="print">
            <div class="print-header">
                {{createYear}}年&nbsp;&nbsp;{{schoolInfo.name}}&nbsp;&nbsp;新生招生登记表
            </div>
            <div class="print-header print-header--sub">
                预报名号：{{orderNo}}&nbsp;&nbsp;
                <template v-if="fromOffline">状态：
                    <span v-if="finalState === 1">二审通过</span>
                    <span v-else-if="finalState === 2">不同意一审意见</span>
                    <span v-else-if="offlineState === -1">一审待定</span>
                    <span v-else-if="offlineState === 0">一审未审核</span>
                    <span v-else-if="offlineState === 1">一审通过</span>
                    <span v-else-if="offlineState === 2">待上报</span>
                </template>
                <span class="order-no" v-if="hasName('applyNo')">报名编号：{{signupInfo.applyNo}}</span>

            </div>
            <div class="print-header print-header--sub">
                <span v-if="isSysStu === 0">系统外学生</span><span v-else-if="isSysStu === 1">系统内学生</span>
            </div>
            <div class="section section--general-info">
                <div class="section-header">
                    基本信息
                    <div class="section-header__bottom-block">
                    </div>
                </div>
                <div class="section-body">
                    <div
                        v-if="hasName('childPhoto') && signupInfo.childPhotoPhoto && signupInfo.childPhotoPhoto.length !== 0"
                        :class="['section-body__left-block', schoolInfo.id == 191 && fromOffline ? 'noprint' : '']"
                        style="text-align: center;">
                        <image-previewer tag="richtext" viewclass="student-photo"
                                         :images="[signupInfo.childPhotoPhoto[0]]">
                            <img class="student-photo" :src="signupInfo.childPhotoPhoto[0].photoUrl"/>
                        </image-previewer>
                    </div>
                    <div
                        :class="['section-body__right-block', schoolInfo.id == 191 && fromOffline ? 'printToleft' : '']">
                        <div class="student-info-item base-info">
                            <div class="student-name">{{signupInfo.stuName}}</div>
                        </div>
                        <div class="student-info-item base-info">
                            <span class="student-info-item__label">性别：</span>
                            <span class="student-info-item__value">{{signupInfo.gender  === 1 ? '男' : '女' }}</span>
                        </div>
                        <div class="student-info-item base-info">
                            <span class="student-info-item__label">出生日期：</span>
                            <span class="student-info-item__value">{{signupInfo.birthday}}</span>
                        </div>
                        <div class="student-info-item base-info">
                            <span class="student-info-item__label">身份证/护照号：</span>
                            <span class="student-info-item__value">{{signupInfo.idCard}}</span>
                        </div>

                        <div class="student-info-item base-info" v-if="hasName('stature')">
                            <span class="student-info-item__label">身高：</span>
                            <span class="student-info-item__value">{{signupInfo.stature }}</span>
                        </div>
                        <div class="student-info-item base-info" v-if="hasName('weight')">
                            <span class="student-info-item__label">体重：</span>
                            <span class="student-info-item__value">{{signupInfo.weight }}</span>
                        </div>

                        <div class="student-info-item" v-if="hasName('interests')">
                            <span class="student-info-item__label">兴趣爱好特长：</span>
                            <span class="student-info-item__value">{{signupInfo.interests}}</span>
                        </div>
                         <div class="student-info-item" v-if="hasName('familyJyln')">
                            <span class="student-info-item__label">家庭教育理念：</span>
                            <span class="student-info-item__value">{{signupInfo.familyJyln}}</span>
                        </div>
                         <div class="student-info-item" v-if="hasName('childJynYdsm')">
                            <span class="student-info-item__label">孩子近一年来的阅读书目：</span>
                            <span class="student-info-item__value">{{signupInfo.childJynYdsm}}</span>
                        </div>
                         <div class="student-info-item" v-if="hasName('childZxhHdxm')">
                            <span class="student-info-item__label">孩子最喜欢的亲子活动项目：</span>
                            <span class="student-info-item__value">{{signupInfo.childZxhHdxm}}</span>
                        </div>
                        <div class="student-info-item" v-if="hasName('nation')">
                            <span class="student-info-item__label">民族：</span>
                            <span class="student-info-item__value">{{signupInfo.nation}}</span>
                        </div>
                        <div class="student-info-item" v-if="hasName('nativePlace')">
                            <span class="student-info-item__label">籍贯：</span>
                            <span class="student-info-item__value">{{signupInfo.nativePlace}}</span>
                        </div>
                        <div v-if="hasName('graduateSchool')" class="student-info-item">
                            <span class="student-info-item__label">毕业学校：</span>
                            <span class="student-info-item__value">{{signupInfo.graduateSchool}}</span>
                        </div>
                        <div v-if="hasName('graduateClass')" class="student-info-item">
                            <span class="student-info-item__label">所在班级：</span>
                            <span class="student-info-item__value">{{signupInfo.graduateClass}}</span>
                        </div>
                        <div v-if="hasName('homeCity')" class="student-info-item">
                            <span class="student-info-item__label">家庭住址：</span>
                            <span class="student-info-item__value">{{signupInfo.homeProvName}}&nbsp;&nbsp;{{signupInfo.homeCityName}}&nbsp;&nbsp;{{signupInfo.homeCountyName}}&nbsp;&nbsp;{{signupInfo.homeAddress}}</span>
                        </div>
                        <div v-if="hasName('birthSite')" class="student-info-item">
                            <span class="student-info-item__label">出生地：</span>
                            <span class="student-info-item__value">{{signupInfo.birthProvName}}&nbsp;&nbsp;{{signupInfo.birthCityName}}&nbsp;&nbsp;{{signupInfo.birthCountyName}}&nbsp;&nbsp;{{signupInfo.birthAddress}}</span>
                        </div>
                        <div v-if="hasName('nodeType')" class="student-info-item">
                            <span class="student-info-item__label">户口类型：</span>
                            <span class="student-info-item__value">{{signupInfo.nodeType | getNodeTypeText }}</span>
                        </div>
                        <div v-if="hasName('isTeachAreaStu')" class="student-info-item">
                            <span class="student-info-item__label">是否施教区学生：</span>
                            <span class="student-info-item__value">{{signupInfo.isTeachAreaStu==1?'是':'否'}}</span>
                        </div>
                        <div v-if="hasName('birthCertificateNo')" class="student-info-item">
                            <span class="student-info-item__label">出生证编号：</span>
                            <span class="student-info-item__value">{{signupInfo.birthCertificateNo }}</span>
                        </div>
                        <div v-if="hasName('isSingleton')" class="student-info-item">
                            <span class="student-info-item__label">是否独生子女：</span>
                            <span class="student-info-item__value">{{signupInfo.isSingleton === 1 ? '是' : '否'}}</span>
                        </div>
                    </div>
                </div>

            </div>

            <div :class="['section','section--general-info', schoolInfo.id == 191 && fromOffline ? 'noprint' : '']">
                <div class="section-header">
                    证明材料
                    <div class="section-header__bottom-block">
                    </div>
                </div>
                <div class="section-body noprint">
                    <div class="line-container">
                        <div class="pic-container" v-if="hasName('birthProve') && signupInfo.birthProve === 1">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>出生证明</span></span>
                            <span class="pic noprint">
                            <image-previewer tag="richtext" viewclass="image-container"
                                             :images="signupInfo.birthProvePhoto">
                                <img v-for="(picItem, picIndex) in signupInfo.birthProvePhoto" class="image-container"
                                     :src="picItem.photoUrl"/>
                            </image-previewer>
                        </span>
                            <span class="pic print-only print-only--inline-block">有</span>
                        </div>
                        <div class="pic-container" v-if="hasName('vaccinateProve') && signupInfo.vaccinateProve === 1">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>接种证明</span></span>
                            <span class="pic noprint">
                            <image-previewer tag="richtext" viewclass="image-container"
                                             :images="signupInfo.vaccinateProvePhoto">
                                <img v-for="(picItem, picIndex) in signupInfo.vaccinateProvePhoto"
                                     class="image-container"
                                     :src="picItem.photoUrl"/>
                            </image-previewer>
                        </span>
                            <span class="pic print-only print-only--inline-block">有</span>
                        </div>
                    </div>

                    <div class="line-container">
                        <div class="pic-container" v-if="hasName('isBigBoy')">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>非大孩</span></span>
                            <span class="pic">
                            <span>{{signupInfo.isBigBoy === 1 ? '是' : '否'}}</span>
                        </span>
                        </div>
                        <!-- <div class="pic-container noprint" v-if="hasName('isBigBoy') && signupInfo.isBigBoy === 1">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>准生证</span></span>
                            <span class="pic">
                                <image-previewer tag="richtext" viewclass="image-container"
                                                 :images="signupInfo.isBigBoyPhoto">
                                    <img v-for="(picItem, picIndex) in signupInfo.isBigBoyPhoto" class="image-container"
                                         :src="picItem.photoUrl"/>
                                </image-previewer>
                            </span>
                        </div> -->
                    </div>

                    <div class="line-container">
                        <div class="pic-container" v-if="hasName('isSingleParent')">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>单亲家庭</span></span>
                            <span class="pic">
                            <span>{{signupInfo.isSingleParent === 1 ? '是' : '否'}}</span>
                        </span>
                        </div>
                        <div class="pic-container noprint"
                             v-if="hasName('isSingleParent') && signupInfo.isSingleParent === 1">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>单亲家庭证明</span></span>
                            <span class="pic"
                                  v-if="signupInfo.isSingleParentPhoto && signupInfo.isSingleParentPhoto.length !== 0">
                                <image-previewer tag="richtext" viewclass="image-container"
                                                 :images="signupInfo.isSingleParentPhoto">
                                    <img v-for="(picItem, picIndex) in signupInfo.isSingleParentPhoto"
                                         class="image-container"
                                         :src="picItem.photoUrl"/>
                                </image-previewer>
                            </span>
                            <span class="pic" v-else>无</span>
                        </div>
                    </div>

                    <div class="line-container">
                        <div class="pic-container" v-if="hasName('isMajorDis')">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>重大疾病或过敏史</span></span>
                            <span class="pic">
                            <span>{{signupInfo.isMajorDis === 1 ? signupInfo.majorDisRemark : '无'}}</span>
                        </span>
                        </div>
                        <div class="pic-container noprint" v-if="hasName('isMajorDis') && signupInfo.isMajorDis === 1">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>大病及过敏证明</span></span>
                            <span class="pic">
                                <image-previewer tag="richtext" viewclass="image-container"
                                                 :images="signupInfo.isMajorDisPhoto">
                                    <img v-for="(picItem, picIndex) in signupInfo.isMajorDisPhoto"
                                         class="image-container"
                                         :src="picItem.photoUrl"/>
                                </image-previewer>
                            </span>
                        </div>
                    </div>

                    <div class="line-container">
                        <div class="pic-container" v-if="hasName('isOnlyChild')">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>是否独生子女</span></span>
                            <span class="pic">
                            <span>{{signupInfo.isOnlyChild === 1 ? '是' : '否'}}</span>
                        </span>
                        </div>
                        <div class="pic-container noprint"
                             v-if="hasName('isOnlyChild') && signupInfo.isOnlyChild === 1">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>独生子女证</span></span>
                            <span class="pic">
                                <image-previewer tag="richtext" viewclass="image-container"
                                                 :images="signupInfo.isOnlyChildPhoto">
                                    <img v-for="(picItem, picIndex) in signupInfo.isOnlyChildPhoto"
                                         class="image-container"
                                         :src="picItem.photoUrl"/>
                                </image-previewer>
                            </span>
                        </div>
                    </div>

                    <div class="line-container">
                        <div class="pic-container" v-if="hasName('isSoldierChild')">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>是否现役军人子女</span></span>
                            <span class="pic">
                            <span>{{signupInfo.isSoldierChild === 1 ? '是' : '否'}}</span>
                        </span>
                        </div>
                        <div class="pic-container noprint"
                             v-if="hasName('isSoldierChild') && signupInfo.isSoldierChild === 1">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>军人子女证明</span></span>
                            <span class="pic">
                            <image-previewer tag="richtext" viewclass="image-container"
                                             :images="signupInfo.isSoldierChildPhoto">
                                <img v-for="(picItem, picIndex) in signupInfo.isSoldierChildPhoto"
                                     class="image-container"
                                     :src="picItem.photoUrl"/>
                            </image-previewer>
                        </span>
                        </div>
                    </div>
                </div>

                <div class="section-body print-only" style="padding:20px 20px 10px 20px">
                    <div class="pic-container" v-if="hasName('birthProve') && signupInfo.birthProve === 1">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>出生证明</span></span>
                        <span class="pic noprint">
                            <image-previewer tag="richtext" viewclass="image-container"
                                             :images="signupInfo.birthProvePhoto">
                                <img v-for="(picItem, picIndex) in signupInfo.birthProvePhoto" class="image-container"
                                     :src="picItem.photoUrl"/>
                            </image-previewer>
                        </span>
                        <span class="pic print-only print-only--inline-block">有</span>
                    </div>
                    <div class="pic-container" v-if="hasName('vaccinateProve') && signupInfo.vaccinateProve === 1">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>接种证明</span></span>
                        <span class="pic noprint">
                            <image-previewer tag="richtext" viewclass="image-container"
                                             :images="signupInfo.vaccinateProvePhoto">
                                <img v-for="(picItem, picIndex) in signupInfo.vaccinateProvePhoto"
                                     class="image-container"
                                     :src="picItem.photoUrl"/>
                            </image-previewer>
                        </span>
                        <span class="pic print-only print-only--inline-block">有</span>
                    </div>

                    <div class="pic-container" v-if="hasName('isBigBoy')">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>非大孩</span></span>
                        <span class="pic">
                            <span>{{signupInfo.isBigBoy === 1 ? '是' : '否'}}</span>
                        </span>
                    </div>
                    <!-- <div class="pic-container noprint" v-if="hasName('isBigBoy') && signupInfo.isBigBoy === 1">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>准生证</span></span>
                        <span class="pic">
                                <image-previewer tag="richtext" viewclass="image-container"
                                                 :images="signupInfo.isBigBoyPhoto">
                                    <img v-for="(picItem, picIndex) in signupInfo.isBigBoyPhoto" class="image-container"
                                         :src="picItem.photoUrl"/>
                                </image-previewer>
                            </span>
                    </div> -->

                    <div class="pic-container" v-if="hasName('isSingleParent')">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>单亲家庭</span></span>
                        <span class="pic">
                            <span>{{signupInfo.isSingleParent === 1 ? '是' : '否'}}</span>
                        </span>
                    </div>
                    <div class="pic-container noprint"
                         v-if="hasName('isSingleParent') && signupInfo.isSingleParent === 1">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>单亲家庭证明</span></span>
                        <span class="pic"
                              v-if="signupInfo.isSingleParentPhoto && signupInfo.isSingleParentPhoto.length !== 0">
                                <image-previewer tag="richtext" viewclass="image-container"
                                                 :images="signupInfo.isSingleParentPhoto">
                                    <img v-for="(picItem, picIndex) in signupInfo.isSingleParentPhoto"
                                         class="image-container"
                                         :src="picItem.photoUrl"/>
                                </image-previewer>
                            </span>
                        <span class="pic" v-else>无</span>
                    </div>

                    <div class="pic-container" v-if="hasName('isMajorDis')">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>重大疾病或过敏史</span></span>
                        <span class="pic">
                            <span>{{signupInfo.isMajorDis === 1 ? signupInfo.majorDisRemark : '无'}}</span>
                        </span>
                    </div>
                    <div class="pic-container noprint" v-if="hasName('isMajorDis') && signupInfo.isMajorDis === 1">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>大病及过敏证明</span></span>
                        <span class="pic">
                                <image-previewer tag="richtext" viewclass="image-container"
                                                 :images="signupInfo.isMajorDisPhoto">
                                    <img v-for="(picItem, picIndex) in signupInfo.isMajorDisPhoto"
                                         class="image-container"
                                         :src="picItem.photoUrl"/>
                                </image-previewer>
                            </span>
                    </div>


                    <div class="pic-container" v-if="hasName('isOnlyChild')">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>是否独生子女</span></span>
                        <span class="pic">
                            <span>{{signupInfo.isOnlyChild === 1 ? '是' : '否'}}</span>
                        </span>
                    </div>
                    <div class="pic-container noprint" v-if="hasName('isOnlyChild') && signupInfo.isOnlyChild === 1">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>独生子女证</span></span>
                        <span class="pic">
                                <image-previewer tag="richtext" viewclass="image-container"
                                                 :images="signupInfo.isOnlyChildPhoto">
                                    <img v-for="(picItem, picIndex) in signupInfo.isOnlyChildPhoto"
                                         class="image-container"
                                         :src="picItem.photoUrl"/>
                                </image-previewer>
                            </span>
                    </div>

                    <div class="pic-container" v-if="hasName('isSoldierChild')">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>是否现役军人子女</span></span>
                        <span class="pic">
                            <span>{{signupInfo.isSoldierChild === 1 ? '是' : '否'}}</span>
                        </span>
                    </div>
                    <div class="pic-container noprint"
                         v-if="hasName('isSoldierChild') && signupInfo.isSoldierChild === 1">
                                    <span class="info-item__label"><i
                                        class="icon icon--record"></i><span>军人子女证明</span></span>
                        <span class="pic">
                            <image-previewer tag="richtext" viewclass="image-container"
                                             :images="signupInfo.isSoldierChildPhoto">
                                <img v-for="(picItem, picIndex) in signupInfo.isSoldierChildPhoto"
                                     class="image-container"
                                     :src="picItem.photoUrl"/>
                            </image-previewer>
                        </span>
                    </div>
                </div>

            </div>


            <div v-if="hasName('parentsInfo')" class="section section--parents-info">
                <div class="section-header">
                    监护人信息
                    <div class="section-header__bottom-block">
                    </div>
                </div>
                <div class="section-body section-body--parent">
                    <div class="parent-info-container" v-if="signupInfo.father">
                        <div class="info-item" v-if="hasName('parentName')">
                            <span class="info-item__label">第一监护人：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.father.parentName}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('nickCode')">
                            <span class="info-item__label">与孩子关系：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.father.nickName}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('dutyType')">
                            <span class="info-item__label">职业类型：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.father.dutyTypeName}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('parentWorkPlace')">
                            <span class="info-item__label">工作单位：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.father.workPlace}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('duty')">
                            <span class="info-item__label">职务：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.father.duty}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('parentIdCard')">
                            <span class="info-item__label">身份证号：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.father.idCard}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('parentEducation')">
                            <span class="info-item__label">学历：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.father.education}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('parentMobile')">
                            <span class="info-item__label">手机号码：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.father.phone}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('residenceAddress')">
                            <span class="info-item__label">户籍所在地：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.father.resProvName}}&nbsp;{{signupInfo.father.resCityName}}&nbsp;{{signupInfo.father.resCountyName}}&nbsp;{{signupInfo.father.residenceAddress}}
                                    </span>
                                </span>
                        </div>
                    </div>
                    <div class="parent-info-container" v-if="signupInfo.mather">
                        <div class="info-item" v-if="hasName('parentName')">
                            <span class="info-item__label">第二监护人：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.mather.parentName}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('nickCode')">
                            <span class="info-item__label">与孩子关系：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.mather.nickName}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('dutyType')">
                            <span class="info-item__label">职业类型：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.mather.dutyTypeName}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('parentWorkPlace')">
                            <span class="info-item__label">工作单位：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.mather.workPlace}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('duty')">
                            <span class="info-item__label">职务：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.mather.duty}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('parentIdCard')">
                            <span class="info-item__label">身份证号：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.mather.idCard}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('parentEducation')">
                            <span class="info-item__label">学历：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.mather.education}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('parentMobile')">
                            <span class="info-item__label">手机号码：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.mather.phone}}
                                    </span>
                                </span>
                        </div>
                        <div class="info-item" v-if="hasName('residenceAddress')">
                            <span class="info-item__label">户籍所在地：</span>
                            <span class="info-item__value">
                                    <span>
                                    {{signupInfo.mather.resProvName}}&nbsp;{{signupInfo.mather.resCityName}}&nbsp;{{signupInfo.mather.resCountyName}}&nbsp;{{signupInfo.mather.residenceAddress}}
                                    </span>
                                </span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="hasName('healthTravelCode')" class="section section--parents-info">
                <div class="section-header">
                    健康码及行程码
                    <div class="section-header__bottom-block">
                    </div>
                </div>
                <div class="section-body">
                    <div class="pic-container">
                        <span class="pic">
                            <image-previewer tag="richtext" viewclass="image-container"
                                             :images="signupInfo.healthTravelPics">
                                <img v-for="(picItem, picIndex) in signupInfo.healthTravelPics" class="image-container"
                                     :src="picItem.photoUrl || picItem.fileUrl"/>
                            </image-previewer>
                        </span>
                    </div>
                </div>
            </div>
            <div class="section section--address-info">
                <div class="section-header">
                    户籍信息
                    <div class="section-header__bottom-block">
                    </div>
                </div>
                <div class="section-body">
                    <div class="info-item" v-if="hasName('houseHolder')">
                        <span class="info-item__label">户主姓名：</span>
                        <span class="info-item__value">
                                <span>{{signupInfo.stuPropertyList[0].houseHolder}}</span>
                            </span>
                    </div>

                    <div class="info-item" v-if="hasName('holderRelation')">
                        <span class="info-item__label">与孩子关系：</span>
                        <span class="info-item__value">
                                <span>{{signupInfo.stuPropertyList[0].holderRelation | parseHolderRelation}}</span>
                            </span>
                    </div>

                    <div class="info-item" v-if="hasName('settleTime')">
                        <span class="info-item__label">学生落户时间：</span>
                        <span class="info-item__value">
                                <span>{{signupInfo.stuPropertyList[0].settleTime}}</span>
                            </span>
                    </div>

                    <div class="info-item" v-if="hasName('accAddress')">
                        <span class="info-item__label">户籍地址：</span>
                        <span class="info-item__value">
                            <span>
                                <span v-if="signupInfo.stuPropertyList[0].accProvName">
                                {{signupInfo.stuPropertyList[0].accProvName}}&nbsp;{{signupInfo.stuPropertyList[0].accCityName}}&nbsp;{{signupInfo.stuPropertyList[0].accCountyName}}
                            </span>
                                    {{signupInfo.stuPropertyList[0].accAddress}}
                                    {{signupInfo.stuPropertyList[0].accAddress ? '&nbsp;&nbsp;' : ''}}
                                    {{signupInfo.stuPropertyList[0].accDetAddress}}
                                    {{signupInfo.stuPropertyList[0].accDetSupplement ? '&nbsp;&nbsp;' : ''}}
                                    {{signupInfo.stuPropertyList[0].accDetSupplement}}
                                </span>
                        </span>
                    </div>
                    <div class="info-item noprint" v-if="hasName('addressPhoto')">
                        <span class="info-item__label">户口本：</span>
                        <span class="info-item__value">
                            <image-previewer tag="richtext" viewclass="image-container"
                                             :images="signupInfo.addressPhotoPhoto">
                                <img v-for="(picItem) in signupInfo.addressPhotoPhoto" class="image-container"
                                     :src="picItem.photoUrl"/>
                            </image-previewer>
                        </span>
                    </div>
                    <div class="info-item"
                         v-if="hasName('otherCertificate') && signupInfo.otherCertificatePhoto && signupInfo.otherCertificatePhoto.length !== 0">
                        <span class="info-item__label">非本户籍地址户口证明：</span>
                        <span class="info-item__value">
                            <image-previewer tag="richtext" viewclass="image-container"
                                             :images="signupInfo.otherCertificatePhoto">
                                <img v-for="(picItem, picIndex) in signupInfo.otherCertificatePhoto"
                                     class="image-container"
                                     :src="picItem.photoUrl"/>
                            </image-previewer>
                        </span>
                    </div>
                </div>
            </div>

            <div class="section section--address-info">
                <div class="section-header">
                    产权信息
                    <div class="section-header__bottom-block">
                    </div>
                </div>
                <div class="section-body">
                    <div class="info-item" v-if="hasName('propertyType')">
                        <span class="info-item__label">产权类型：</span>
                        <span class="info-item__value">
                                <span>{{signupInfo.stuPropertyList[0].propertyTypeName}}</span>
                            </span>
                    </div>
                    <div class="info-item"
                         v-if="hasName('propertyTypeRemark') && signupInfo.stuPropertyList[0].propertyTypeCode == 109">
                        <span class="info-item__label">产权类型备注：</span>
                        <span class="info-item__value">
                                <span>{{signupInfo.stuPropertyList[0].propertyTypeRemark}}</span>
                            </span>
                    </div>
                    <div class="info-item" v-if="hasName('propertyNo')">
                        <span class="info-item__label">产权/租赁证号：</span>
                        <span class="info-item__value">
                                <span>{{signupInfo.stuPropertyList[0].propertyNo}}</span>
                            </span>
                    </div>

                    <div class="info-item" v-if="hasName('propertyHolder')">
                        <span class="info-item__label">所有产权人姓名：</span>
                        <span class="info-item__value">
                                <span>{{signupInfo.stuPropertyList[0].propertyHolder}}</span>
                            </span>
                    </div>
                    <div class="info-item" v-if="hasName('withChildRelation')">
                        <span class="info-item__label">产权人与孩子关系：</span>
                        <span class="info-item__value">
                                <span>{{signupInfo.stuPropertyList[0].withChildRelationDes}}</span>
                            </span>
                    </div>
                    <div class="info-item" v-if="hasName('propertyRelation')">
                        <span class="info-item__label">产权关系：</span>
                        <span class="info-item__value">
                                <span>{{signupInfo.stuPropertyList[0].propertyRelation | parsePropertyRelation}}</span>
                            </span>
                    </div>
                    <div class="info-item"
                         v-if="hasName('propertyRatio') && signupInfo.stuPropertyList[0].propertyRelation == 8">
                        <span class="info-item__label">产权占比：</span>
                        <span class="info-item__value">
                            <span v-if="ratioItem.name" v-for="ratioItem in signupInfo.propertyRatioList">产权人：{{ratioItem.name}}&nbsp;&nbsp;关系：{{ratioItem.relation}}</span>
                        </span>
                    </div>
                    <div class="info-item"
                         v-if="hasName('propertyNaProve') && signupInfo.stuPropertyList[0].propertyRelation == 2">
                        <span class="info-item__label">无房证明：</span>
                        <span class="info-item__value">
                            <image-previewer tag="richtext" viewclass="image-container"
                                             :images="signupInfo.propertyNaProvePhoto">
                                <img v-for="(picItem, picIndex) in signupInfo.propertyNaProvePhoto"
                                     class="image-container"
                                     :src="picItem.photoUrl"/>
                            </image-previewer>
                        </span>
                    </div>
                    <div class="info-item" v-if="hasName('propertyAddress') && signupInfo.stuPropertyList[0].propertyRelation != 6">
                        <span class="info-item__label">产权地址：</span>
                        <span class="info-item__value">
                            <span>
                                {{signupInfo.stuPropertyList[0].propertyAddress}}
                                {{signupInfo.stuPropertyList[0].propertyAddress ? '&nbsp;&nbsp;' : ''}}
                                {{signupInfo.stuPropertyList[0].propertyDetAddress}}
                                {{signupInfo.stuPropertyList[0].propertyDetSupplement ? '&nbsp;&nbsp;' : ''}}
                                {{signupInfo.stuPropertyList[0].propertyDetSupplement}}
                            </span>
                        </span>
                    </div>
                    <div class="info-item" v-if="hasName('propertyTime') && signupInfo.stuPropertyList[0].propertyRelation != 6">
                        <span class="info-item__label">产权登记时间：</span>
                        <span class="info-item__value">
                                <span> {{signupInfo.stuPropertyList[0].propertyTime}}</span>
                            </span>
                    </div>
                    <div class="info-item" v-if="hasName('propertyArea') && signupInfo.stuPropertyList[0].propertyRelation != 6">
                        <span class="info-item__label">建筑面积：</span>
                        <span class="info-item__value">
                                <span> {{signupInfo.stuPropertyList[0].propertyArea}}</span>
                            </span>
                    </div>
                    <div class="info-item" v-if="hasName('qiuNo') && signupInfo.stuPropertyList[0].propertyRelation != 6">
                        <span class="info-item__label">丘权号：</span>
                        <span class="info-item__value">
                                <span> {{signupInfo.stuPropertyList[0].qiuNo}}</span>
                            </span>
                    </div>
                    <div class="info-item" v-if="hasName('sectionNo') && signupInfo.stuPropertyList[0].propertyRelation != 6">
                        <span class="info-item__label">路段号：</span>
                        <span class="info-item__value">
                                <span> {{signupInfo.stuPropertyList[0].sectionNo}}</span>
                            </span>
                    </div>
                    <div class="info-item" v-if="hasName('isLive')">
                        <span class="info-item__label">是否实际居住：</span>
                        <span class="info-item__value">
                                <span> {{signupInfo.stuPropertyList[0].isLive === 1 ? '是' : '否'}}</span>
                            </span>
                    </div>
                    <div class="info-item" v-if="hasName('actualAddress') && signupInfo.stuPropertyList[0].isLive == 2">
                        <span class="info-item__label">实际居住地址：</span>
                        <span class="info-item__value">
                            <span>
                                <span v-if="signupInfo.actualProvName">{{signupInfo.actualProvName}}&nbsp;{{signupInfo.actualCityName}}&nbsp;{{signupInfo.actualCountyName}}</span>
                                {{signupInfo.actualAddress}}
                            </span>
                        </span>
                    </div>
                    <div class="info-item" v-if="hasName('liveMembers') && signupInfo.stuPropertyList[0].isLive == 1">
                        <span class="info-item__label">实际居住人员：</span>
                        <span class="info-item__value">
                                <span> {{signupInfo.stuPropertyList[0].liveMembers}}</span>
                            </span>
                    </div>
                    <div class="info-item noprint" v-if="hasName('propertyPhoto') && signupInfo.stuPropertyList[0].propertyRelation != 6">
                        <span class="info-item__label">产权证照片：</span>
                        <span class="info-item__value">
                            <image-previewer tag="richtext" viewclass="image-container"
                                             :images="signupInfo.propertyPhotoPhoto">
                                <img v-for="(picItem) in signupInfo.propertyPhotoPhoto"
                                     class="image-container"
                                     :src="picItem.photoUrl"/>
                            </image-previewer>
                        </span>
                    </div>
                    <div class="info-item"
                         v-if="hasName('houseDetailsPhotos') && signupInfo.houseDetailsPics && signupInfo.houseDetailsPics.length !== 0 && signupInfo.stuPropertyList[0].propertyRelation != 6">
                        <span class="info-item__label">房屋信息照：</span>
                        <span class="info-item__value">
                            <image-previewer tag="richtext" viewclass="image-container"
                                             :images="signupInfo.houseDetailsPics">
                                <img v-for="(picItem, picIndex) in signupInfo.houseDetailsPics" class="image-container"
                                     :src="picItem.photoUrl || picItem.fileUrl"/>
                            </image-previewer>
                        </span>
                    </div>
                    <div class="info-item" v-if="hasName('propertyRemark')"
                         style="clear: both;width: 98%; float: none;">
                        <span class="info-item__label" style="width: 16%">备注：</span>
                        <span class="info-item__value">
                            {{signupInfo.stuPropertyList[0].propertyRemark}}
                        </span>
                    </div>
                </div>
            </div>
            <div class="section section--address-info" v-if="hasName('confirmHint')">
                <div class="section-header">
                    家长确认签字
                    <div class="section-header__bottom-block">
                    </div>
                </div>
                <div class="section-body">
                    <div class="info-item info-item--wide">
                        <div v-html="confirmText">
                        </div>
                    </div>
                </div>
            </div>
            <div class="section section--address-info" v-if="
                hasName('isRealLive') ||
                hasName('isTeachArea') ||
                hasName('isTeachAreaNotice') ||
                hasName('isProperty') ||
                hasName('isVisit') ||
                hasName('otherReview')
            ">
                <div class="section-header" v-if="
                hasName('isRealLive') ||
                hasName('isTeachArea') ||
                hasName('isTeachAreaNotice') ||
                hasName('isProperty') ||
                hasName('isVisit') ||
                hasName('otherReview')
            ">
                    审核信息
                    <div class="section-header__bottom-block">
                    </div>
                </div>
                <div class="section-body">
                    <div class="info-item" v-if="hasName('isRealLive')">
                        <span class="info-item__label">实际居住：</span>
                        <span class="info-item__value"></span>
                    </div>
                    <div class="info-item" v-if="hasName('isTeachArea')">
                        <span class="info-item__label">施教区：</span>
                        <span class="info-item__value"></span>
                    </div>
                    <div class="info-item" v-if="hasName('isTeachAreaNotice')">
                        <span class="info-item__label">施教区入学审核通知：</span>
                        <span class="info-item__value"></span>
                    </div>
                    <div class="info-item" v-if="hasName('isProperty')">
                        <span class="info-item__label">父母产权：</span>
                        <span class="info-item__value"></span>
                    </div>
                    <div class="info-item" v-if="hasName('isLocalRegister')">
                        <span class="info-item__label">户籍所在地：</span>
                        <span class="info-item__value"></span>
                    </div>
                    <div class="info-item" v-if="hasName('isVisit')">
                        <span class="info-item__label">是否家访：</span>
                        <span class="info-item__value"></span>
                    </div>
                    <div class="info-item info-item--wide" v-if="hasName('otherReview')">
                        <div v-html="parseHtmlFormat(otherReviewText)">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="review-list-section">
            <div class="review-list-container">
                <h2>学位被占用情况</h2>
                <el-tag type="success" v-if="isDegreeOccupy == 0">未占用</el-tag>
                <el-tag type="danger" v-if="isDegreeOccupy == 1">已占用</el-tag>
                <br/>
                <br/>
            </div>
            <template v-if="liveInfoList && liveInfoList.length !== 0">
                <div class="review-list-container">
                    <h2>实际居住情况</h2>
                    <ul class="review-list review-list--live">
                        <li class="review-item for" v-for="liveInfo in liveInfoList">
                            <div class="review-item__state">
                                <el-tag type="success" v-if="liveInfo.isLiveActual === 1">确定实际居住</el-tag>
                                <el-tag type="danger" v-if="liveInfo.isLiveActual === 2">疑似非实际居住</el-tag>
                                <el-tag type="danger" v-if="liveInfo.isLiveActual === 3">确定非实际居住</el-tag>
                            </div>
                            <div class="review-item__detail">
                                <div class="review-item__remark">
                                    {{liveInfo.remark}}
                                </div>
                                <div class="review-item__info">
                                    {{liveInfo.remarkUserName}}
                                    {{liveInfo.remarkTime | timeFilter}}
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </template>
            <template v-else-if="signupInfo.isLiveActual != 0">
                <div class="review-list-container">
                    <h2>实际居住情况</h2>
                    <ul class="review-list">
                        <li class="review-item">
                            <div class="review-item__state">
                                <el-tag type="success" v-if="signupInfo.isLiveActual === 1">确定实际居住</el-tag>
                                <el-tag type="danger" v-if="signupInfo.isLiveActual === 2">疑似非实际居住</el-tag>
                                <el-tag type="danger" v-if="signupInfo.isLiveActual === 3">确定非实际居住</el-tag>
                            </div>
                            <div class="review-item__detail">
                                <div>
                                    {{signupInfo.liveRemark}}
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </template>
            <div class="review-list-container">
                <h2>网审一审，审核情况</h2>
                <ul class="review-list">
                    <li class="review-item for" v-for="reviewItem in reviewList">
                        <div class="review-item__state">
                            <el-tag type="success" v-if="reviewItem.status === 1">通过</el-tag>
                            <el-tag type="danger" v-else>不通过</el-tag>
                        </div>
                        <div class="review-item__detail">
                            <div>
                                {{getReviewOption(reviewItem.examineCode)}}
                            </div>
                            <div>
                                {{reviewItem.examineRemark}}
                            </div>
                            <div class="review-item__user">
                                {{reviewItem.examineUserName}}&nbsp;&nbsp;{{reviewItem.examineTime | timeSuffixFilter}}
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="review-list-container" v-if="signupInfo.lineExamUser">
                <h2>网审二审，审核情况</h2>
                <ul class="review-list">
                    <li class="review-item">
                        <div class="review-item__state">
                            <el-tag type="success" v-if="signupInfo.lineExamState === 1">通过</el-tag>
                            <el-tag type="danger" v-else>不通过</el-tag>
                        </div>
                        <div class="review-item__detail">
                            <div v-if="signupInfo.lineExamState !== 1">
                                {{signupInfo.lineExamRemark}}
                            </div>
                            <div class="review-item__user">
                                {{signupInfo.lineExamUser}}&nbsp;&nbsp;{{signupInfo.lineExamTime | timeSuffixFilter}}
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="review-list-container" v-if="onelist.length>0">
                <h2>线下一审，审核情况</h2>
                <ul class="review-list">
                    <li class="review-item for" v-for="oneItem in onelist">
                        <div class="review-item__state">
                            <el-tag type="success" v-if="oneItem.status === 1">一审过</el-tag>
                            <el-tag type="danger" v-if="oneItem.status === 2">待上报</el-tag>
                            <el-tag type="danger" v-if="oneItem.status === -1">待再审</el-tag>
                        </div>
                        <div class="review-item__detail">
                            <div>
                                {{oneItem.examineRemark}}
                            </div>
                            <div class="review-item__user">
                                {{oneItem.examineUserName}}&nbsp;&nbsp;{{oneItem.examineTime | timeSuffixFilter}}
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="review-list-container" v-if="twolist.length>0">
                <h2>线下二审，审核情况</h2>
                <ul class="review-list">
                    <li class="review-item for" v-for="twoItem in twolist">
                        <div class="review-item__state">
                            <el-tag type="success" v-if="twoItem.status === 1">通过</el-tag>
                            <el-tag type="danger" v-if="twoItem.status === 2">待上报</el-tag>
                            <el-tag type="danger" v-if="twoItem.status === -1">待确认</el-tag>
                            <el-tag type="danger" v-if="twoItem.status === 4">通过</el-tag>
                        </div>
                        <div class="review-item__detail">
                            <div>
                                {{twoItem.examineRemark}}
                            </div>
                            <div class="review-item__user">
                                {{twoItem.examineUserName}}&nbsp;&nbsp;{{twoItem.examineTime | timeSuffixFilter}}
                            </div>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="review-list-container review-list-container--comment" v-if="commentList.length>0">
                <h2>备注</h2>
                <ul class="review-list review-list--live">
                    <li class="review-item for" v-for="commentItem in commentList">
                        <div class="review-item__state">
                        </div>
                        <div class="review-item__detail">
                            <div>
                                {{commentItem.remark}}
                            </div>

                            <div class="review-item__user">
                                <div class="comment-info">
                                    {{commentItem.remarkUserName}}&nbsp;&nbsp;{{commentItem.remarkTime |
                                    timeSuffixFilter}}
                                </div>
                                <div @click="deleteComment(commentItem.id)"
                                     v-if="userInfo.id === commentItem.remarkUserId"
                                     class="fa fa-close delete-comment-btn"></div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <el-dialog
            title="网审一审"
            :visible.sync="isShowReviewDialog"
            :close-on-click-modal="false"
        >
            <div>
                网审一审审核意见：
                <el-select v-model="reviewFormData.examineCode" placeholder="请选择">
                    <el-option
                        v-for="item in reviewOptionList"
                        :key="item.code"
                        :label="item.value"
                        :value="item.code">
                    </el-option>
                </el-select>
            </div>
            <div style="margin-top: 10px;">
                网审一审备注：
                <el-input
                    style="width: 90%;vertical-align: top"
                    type="textarea"
                    :rows="4"
                    placeholder="请输入备注"
                    v-model.trim="reviewFormData.examineRemark"
                    :maxlength="100"
                >
                </el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" type="primary" :disabled="btnDisabled" :loading="btnDisabled" @click="review(1)">审核通过</el-button>
                <el-button size="medium" type="primary" :disabled="btnDisabled" :loading="btnDisabled" @click="review(2)">不通过</el-button>
            </span>
        </el-dialog>
        <el-dialog :close-on-click-modal='false' title="网审二审" :visible.sync="examVisible" class="addExamBox">
            <el-form :model="firstExamineQuery" ref="firstExamObject" :rules="firstExamineRule" label-width="140px">
                <el-form-item label="网审二审结果" class="numberBox">
                    <el-radio-group v-model="firstExamineQuery.examineResult">
                        <el-radio :label="1">通过</el-radio>
                        <el-radio :label="2">不通过</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-show="firstExamineQuery.examineResult === 2" label="意见备注" class="numberBox"
                              prop="examinOptions">
                    <el-input
                        type="textarea"
                        :rows="3"
                        :maxlength="100"
                        placeholder="请输入意见"
                        v-model="firstExamineQuery.examinOptions">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="medium" @click="examVisible=false">取 消</el-button>
                <el-button size="medium" type="primary" @click="addTimeHandler()">保 存</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal='false' title="线下一审" :visible.sync="firstReviewVisible" class="addExamBox">
            <el-form :rules="firstReviewRule" :model="firstReviewQuery" ref="firstReviewForm" label-width="140px">
                <el-form-item label="线下一审结果" class="numberBox">
                    <el-radio-group @change="firstStatusChange" v-model="firstReviewQuery.status">
                        <el-radio :label="1">一审过</el-radio>
                        <el-radio :label="-1">待再审</el-radio>
                        <el-radio :label="2">待上报</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="线下一审意见" class="numberBox" prop="examineRemark">
                    <el-input
                        type="textarea"
                        :rows="3"
                        :maxlength="100"
                        placeholder="请输入意见"
                        v-model.trim="firstReviewQuery.examineRemark">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="medium" @click="firstReviewVisible=false">取 消</el-button>
                <el-button size="medium" type="primary" @click="firstReviewSubmit()">保 存</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal='false' title="线下二审" :visible.sync="examVisibletow" class="addExamBox">
            <el-form ref="examObject" label-width="140px" :rules="offlineSecondRule" :model="listQuery">
                <el-form-item label="线下二审结果" class="numberBox">
                    <el-radio-group @change="secondStatusChange" v-model="listQuery.isApprove">
                        <el-radio :label="1">同意一审意见</el-radio>
                        <el-radio :label="2">不同意一审意见</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-show="isShowNotApprove" label="线下二审结果" class="numberBox">
                    <el-radio-group v-model="listQuery.notApproveReason">
                        <el-radio :label="-1">待确认</el-radio>
                        <el-radio :label="2">待上报</el-radio>
                        <el-radio :label="4">通过</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="线下二审意见" class="numberBox" prop="examineRemark">
                    <el-input
                        type="textarea"
                        :rows="3"
                        :maxlength="100"
                        placeholder="请输入意见"
                        v-model="listQuery.examineRemark">
                    </el-input>
                </el-form-item>
                <el-form-item label="父母产权" class="numberBox" v-if="fieldNameList.indexOf('isProperty')!==-1">
                    <el-radio-group v-model="listQuery.isProperty">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否实际居住" class="numberBox" v-if="fieldNameList.indexOf('isRealLive')!==-1">
                    <el-radio-group v-model="listQuery.isRealLive">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="是否施教区" class="numberBox" v-if="fieldNameList.indexOf('isTeachArea')!==-1">
                    <el-radio-group v-model="listQuery.isTeachArea">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="施教区入学审核通知" class="numberBox"
                              v-if="fieldNameList.indexOf('isTeachAreaNotice')!==-1">
                    <el-radio-group v-model="listQuery.isTeachAreaNotice">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否户籍所在地" class="numberBox" v-if="fieldNameList.indexOf('isLocalRegister')!==-1">
                    <el-radio-group v-model="listQuery.isLocalRegister">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否家访" class="numberBox" v-if="fieldNameList.indexOf('isVisit')!==-1">
                    <el-radio-group v-model="listQuery.isVisit">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="medium" @click="examVisibletow=false">取 消</el-button>
                <el-button size="medium" type="primary" @click="addTimeHandlers()">保 存</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal='false' title="备注" :visible.sync="commentVisibility" class="addExamBox">
            <el-form ref="commentForm" :rules="commentRule" :model="commentQuery" label-width="140px">
                <el-form-item label="备注说明" class="numberBox" prop="remark">
                    <el-input
                        type="textarea"
                        :rows="3"
                        :maxlength="100"
                        placeholder="请输入备注说明"
                        v-model.trim="commentQuery.remark">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="medium" @click="commentVisibility = false">取 消</el-button>
                <el-button size="medium" type="primary" @click="comment()">保 存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import ImagePreviewer from '@/components/ImagePreviewer/ImagePreviewer.vue';
    import {regionData, CodeToText} from '@/utils/element-china-area-data'
    import baseMixin from '@/mixins/baseMixin';

    import BackTool from '@/components/BackTool';
    import {
        getNotice
    } from '@/api/primary/notice';
    import {
        getFieldSetInfo,
        getStuDetailById,
        getStuExamineInfoList,
        examineApplyStu,
        offlineFirstExamineStudent,
        finalExamineStudent,
        getStuOfflineOneExamineRecordList,
        getStuOfflineTwoExamineRecordList,
        addStuRemarkRecord,
        delStuRemarkById,
        getStuRemarkRecordList,
        admitStu,
        getStuLiveRemarkRecordList
    } from '@/api/primary/review';
    import {
        secondExamine
    } from '@/api/primary/setting.js';

    import {
        findDicsByCode,
        findSchoolDicsByCode,
        queryById
    } from '@/api/common';

    import moment from 'moment';
    import {mapGetters} from 'vuex';

    export default {
        name: "ReviewQuestionnaireDetail",
        components: {
            BackTool,
            ImagePreviewer
        },
        mixins: [baseMixin],
        data: function () {
            const firstExamineOptionValidator = (rule, value, callback) => {
                if (this.firstExamineQuery.examineResult === 2 && this.firstExamineQuery.examinOptions === '') {
                    callback(new Error('审核意见不能为空！'));
                } else {
                    callback();
                }
            };
            const firstRemarkValidator = (rule, value, callback) => {
                if (this.firstReviewQuery.status !== 1 && this.firstReviewQuery.examineRemark === '') {
                    callback(new Error('审核意见不能为空！'));
                } else {
                    callback();
                }
            };
            const secondRemarkValidator = (rule, value, callback) => {
                if (this.listQuery.isApprove !== 1 && this.listQuery.examineRemark === '') {
                    callback(new Error('审核意见不能为空！'));
                } else {
                    callback();
                }
            };

            return {
                createYear: '',

                orderNo: this.$route.query.orderNo,
                groupType: this.$route.query.groupType,
                fromOnlineReview: this.$route.query.fromOnlineReview == 1,
                fromReserve: this.$route.query.fromReserve == 1,
                state: 1,
                offlineState: 1,
                finalState: 1,

                fromOffline: this.$route.query.fromOffline == 1,
                isShowReviewDialog: false,
                noticeId: this.$route.query.noticeId,
                options: regionData,
                userId: this.$route.query.userId,
                stuId: this.$route.query.stuId,

                updateId: null,
                fieldNameList: [],

                nationList: [],
                propertyTypeList: [],
                teachAreaList: [],

                isAdd: false,
                signupInfo: {
                    father: {},
                    mather: {},
                    stuPropertyList: [{}]
                },
                //线下审核
                onelist: [],
                twolist: [],
                reviewList: [],
                reviewOptionList: [],
                //线下一审
                firstReviewVisible: false,
                firstReviewQuery: {
                    status: 1,
                    examineRemark: '',
                    recStuId: this.$route.query.stuId,
                    offlinePends: '',
                    offlinePendIds: '',
                    offlinePendIdslist: []
                },
                firstReviewRule: {
                    examineRemark: [{
                        required: false, validator: firstRemarkValidator, trigger: 'blur'
                    }],
                    offlinePendIdslist: [
                        {type: 'array', required: true, message: '请至少选择一个待定原因', trigger: 'change'}
                    ],
                },
                offlineSecondRule: {
                    examineRemark: [{
                        required: false, validator: secondRemarkValidator, trigger: 'blur'
                    }],
                },
                commentRule: {
                    remark: [{
                        required: true, message: '请输入备注说明', trigger: 'blur'
                    }]
                },
                commentQuery: {
                    remark: ''
                },
                //线下二审
                examVisible: false,
                isShowNotApprove: false,
                listQuery: {

                    notApproveReason: -1,
                    isApprove: 1,
                    id: this.$route.query.stuId,
                    isProperty: 1,
                    isRealLive: 1,
                    isTeachArea: 1,
                    isTeachAreaNotice: 1,
                    isVisit: 1,
                    isLocalRegister: 1,
                    examineRemark: ''
                },
                groupId: this.$route.query.groupId,
                reviewFormData: {
                    groupId: this.$route.query.groupId,
                    examineCode: '',
                    examineRemark: '',
                    examineValue: '',
                    recStuId: this.$route.query.stuId,
                    status: 0
                },
                examVisibletow: false,

                firstExamineQuery: {
                    examineResult: 1,
                    examinOptions: '',
                },
                firstExamineRule: {
                    examinOptions: [{
                        required: true, validator: firstExamineOptionValidator, trigger: 'blur'
                    }]
                },

                commentVisibility: false,
                commentList: [],

                otherReviewText: '',

                confirmText: '',

                isSysStu: null,

                liveInfoList: [],

                isDegreeOccupy: 0,

                btnDisabled: false
            }
        },
        computed: {
            ...mapGetters(['schoolInfo', 'userInfo', 'permission'])
        },
        filters: {
            getNodeTypeText(value) {
                if (value === '' || value === null) {
                    return ''
                } else {
                    return ['非农业户口', '农业户口', ''][value];
                }
            },
            parsePropertyRelation(value) {
                if (!value) {
                    return ''
                } else {
                    return ['', '孩子父母独立产权', '“四老”房产', '与老人共有房产', '拆迁过渡', '军产房', '无房户口空挂', '集体户口', '与他人共有产权', '其他'][value];
                }
            },
            parseHolderRelation(value) {
                if (!value) {
                    return ''
                } else {
                    return ['', '父子/父女', '母子/母女', '祖孙', '其它'][value];
                }
            },
            timeFilter(value) {
                return value.slice(0, value.lastIndexOf('.'));
            }

        },
        created() {
            getStuLiveRemarkRecordList({
                stuId: this.stuId
            })
                .then(res => res.data)
                .then(data => {
                    this.liveInfoList = data.data;
                });
            getNotice({
                noticeId: this.noticeId
            })
                .then(res => res.data)
                .then(data => {
                    if (data.data.createTime) {
                        this.createYear = data.data.createTime.split('-')[0];
                    }
                });
            this.init();
        },
        methods: {
            init() {
                //线下一审
                getStuOfflineOneExamineRecordList(this.$route.query.stuId).then(res => res.data)
                    .then(data => {
                        this.onelist = data.data

                    });
                //线下二审
                getStuOfflineTwoExamineRecordList(this.$route.query.stuId).then(res => res.data)
                    .then(data => {
                        this.twolist = data.data
                    });

                this.getStuRemarkRecordListFunc();
                this.getStuExamineInfoListFunc();
                findSchoolDicsByCode({
                    dicCode: 'examineOptions',
                    schoolId: this.schoolInfo.id
                })
                    .then(res => res.data)
                    .then(data => {
                        if (data.data.length !== 0 && this.reviewFormData.examineCode === '') {
                            this.reviewFormData.examineCode = data.data[0].code;
                        }
                        this.reviewOptionList = data.data;
                    });

                findDicsByCode({
                    dicCode: 'national'
                })
                    .then(res => res.data)
                    .then(data => {
                        this.nationList = data.data;
                    });

                findDicsByCode({
                    dicCode: 'propertyType'
                })
                    .then(res => res.data)
                    .then(data => {
                        this.propertyTypeList = data.data;
                    });

                queryById({
                    id: this.schoolInfo.id
                })
                    .then(res => res.data)
                    .then(data => {
                        findSchoolDicsByCode({
                            schoolId: this.schoolInfo.id,
                            dicCode: data.data.type === 2 ? 'primaryTeachAreas' : 'middleTeachAreas'
                        })
                            .then(res => res.data)
                            .then(data => {
                                this.teachAreaList = data.data;
                            })
                    });


                getFieldSetInfo({
                    schoolId: this.schoolInfo.id,
                    yearNo: moment().format('YYYY')
                })
                    .then(res => res.data)
                    .then(data => {
                        this.fieldNameList = data.data.map(item => item.fieldName);
                        if (this.hasName('otherReview')) {
                            this.otherReviewText = data.data.find(({fieldName}) => fieldName === 'otherReview').fieldRemark;
                        }
                        if (this.hasName('confirmHint')) {
                            this.confirmText = data.data.find(({fieldName}) => fieldName === 'confirmHint').fieldRemark.replace(/\n/g, '<br />');
                        }

                        getStuDetailById({
                            stuId: this.stuId
                        })
                            .then(res => res.data)
                            .then(data => {
                                this.isDegreeOccupy = data.data.isDegreeOccupy;
                                this.initData(data.data);
                            });
                    })
            },
            signup() {
                this.$confirm('是否录取?', '录取', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    admitStu({
                        stuIds: this.stuId,
                        noticeId: this.noticeId
                    })
                        .then(res => res.data)
                        .then(data => {
                            if (data.result) {
                                this.$message({
                                    message: '录取成功',
                                    type: 'success'
                                });
                                this.init();
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                }).catch(() => {
                });
            },
            firstStatusChange() {
                this.$refs.firstReviewForm.validateField(['examineRemark'])
            },
            secondStatusChange() {
                this.$refs.examObject.validateField(['examineRemark']);
                this.isShowNotApprove = this.listQuery.isApprove !== 1;
            },
            parseHtmlFormat(text) {
                const result = text.replace(/[\n\s]/g, function (catched) {
                    let result = '';
                    switch (catched) {
                        case '\n':
                            result = '<br />';
                            break;
                        case ' ':
                            result = '&nbsp;';
                            break;
                    }
                    return result;
                });
                return result;
            },
            //打印
            print() {
                this.$print(this.$refs.print)
            },

            addTimeHandler() {
                this.$refs.firstExamObject.validate((valid) => {
                    if (valid) {
                        this.examVisible = false;
                        secondExamine({
                            examinOptions: this.firstExamineQuery.examineResult === 1 ? '' : this.firstExamineQuery.examinOptions,
                            examineResult: this.firstExamineQuery.examineResult,
                            groupId: this.groupId,
                            noticeId: this.noticeId,
                            studentId: this.stuId
                        }).then(res => res.data)
                            .then(data => {
                                if (data.code === 200) {
                                    this.$message({
                                        type: 'success',
                                        message: '审核完成！'
                                    });
                                    this.$router.back();
                                }
                            });
                    }
                });
            },
            secondHanlder() {
                this.examVisible = true;
            },
            getStuExamineInfoListFunc() {
                getStuExamineInfoList({
                    recStuId: this.stuId
                })
                    .then(res => res.data)
                    .then(data => {
                        this.reviewList = data.data;
                        if (data.data.length !== 0) {
                            const myReview = data.data.find(({examineUserId}) => examineUserId === this.userInfo.id);
                            if (myReview) {
                                this.reviewFormData.examineCode = myReview.examineCode;
                                this.reviewFormData.examineRemark = myReview.examineRemark;
                            }
                        }
                    });
            },
            review(status) {
                if (this.reviewFormData.examineCode === '') {
                    this.$message.error('请选择审核意见');
                    return undefined;
                }
                this.reviewFormData.examineValue = this.reviewOptionList.find(({code}) => code === this.reviewFormData.examineCode).value;
                this.reviewFormData.status = status;
                this.btnDisabled = true;
                setTimeout(() => {
                    this.btnDisabled = false
                }, 5000);
                examineApplyStu(this.reviewFormData)
                    .then(res => res.data)
                    .then(data => {
                        if (data.result) {
                            this.$message({
                                message: '审核完成',
                                type: 'success'
                            });
                            this.getStuExamineInfoListFunc();
                            this.isShowReviewDialog = false;
                            this.$router.back();
                        }
                    })
            },
            getReviewOption(value) {
                const review = this.reviewOptionList.find(({code}) => code === value);
                return !review ? '' : review.value;
            },
            initData(sourceData) {
                this.state = sourceData.state;
                this.isSysStu = sourceData.isSysStu;
                this.offlineState = sourceData.offlineState;
                this.finalState = sourceData.finalState;

                if (sourceData.stuBasicPicList) {
                    const stuBasicPic = sourceData.stuBasicPicList;

                    const propMapping = [
                        '',
                        'birthProvePhoto',
                        'vaccinateProvePhoto',
                        'childPhotoPhoto',
                        'isOnlyChildPhoto',
                        'isSoldierChildPhoto',
                        'addressPhotoPhoto',
                        'propertyPhotoPhoto',
                        'isSingleParentPhoto',
                        'isMajorDisPhoto',
                        // 'isBigBoyPhoto',
                        'propertyNaProvePhoto',
                        'otherCertificatePhoto'
                    ];
                    stuBasicPic.forEach(picItem => {
                        console.log(11, propMapping[picItem.itemType])
                        picItem.src = picItem.photoUrl;
                        if (sourceData[propMapping[picItem.itemType]]) {
                            sourceData[propMapping[picItem.itemType]].push(picItem);
                        } else {
                            sourceData[propMapping[picItem.itemType]] = [picItem];
                        }

                    })
                }
                if (sourceData.stuPropertyList && sourceData.stuPropertyList[0] && sourceData.stuPropertyList[0].propertyRatio) {
                    sourceData.propertyRatioList = JSON.parse(sourceData.stuPropertyList[0].propertyRatio);
                } else {
                    sourceData.propertyRatioList = [];
                }
                if (sourceData.healthTravelPics) {
                    sourceData.healthTravelPics = JSON.parse(sourceData.healthTravelPics);
                }
                console.log(sourceData)
                if (sourceData.stuPropertyList && sourceData.stuPropertyList[0]) {
                    if (sourceData.stuPropertyJson) {
                        const stuProperty = JSON.parse(sourceData.stuPropertyJson);
                        if (stuProperty.length !== 0 && stuProperty[0].houseDetailsPics) {
                            sourceData.houseDetailsPics = stuProperty[0].houseDetailsPics;
                        }
                    } else if (sourceData.stuPropertyList[0].houseDetailsPics) {
                        sourceData.houseDetailsPics = JSON.parse(sourceData.stuPropertyList[0].houseDetailsPics);
                    }

                }
                this.signupInfo = sourceData;
            },
            hasName(name) {
                return this.fieldNameList.indexOf(name) !== -1;
            },
            // 线下一审
            firstReview() {
                this.firstReviewVisible = true;
                this.firstReviewQuery.examineRemark = '';
                this.firstReviewQuery.status = 1;
            },
            firstReviewSubmit() {
                this.$refs.firstReviewForm.validate((valid) => {
                    if (valid) {
                        offlineFirstExamineStudent(this.firstReviewQuery)
                            .then(res => res.data)
                            .then(data => {
                                if (data.result) {
                                    this.$message({
                                        type: 'success',
                                        message: '线下一审完成！'
                                    });
                                    this.firstReviewVisible = false;
                                    //线下一审
                                    getStuOfflineOneExamineRecordList(this.$route.query.stuId).then(res => res.data)
                                        .then(data => {
                                            this.onelist = data.data

                                        });
                                    //线下二审
                                    getStuOfflineTwoExamineRecordList(this.$route.query.stuId).then(res => res.data)
                                        .then(data => {
                                            this.twolist = data.data
                                        });
                                    getStuDetailById({
                                        stuId: this.stuId
                                    })
                                        .then(res => res.data)
                                        .then(data => {
                                            this.initData(data.data);
                                        });
                                }
                            });
                    }
                });
            },
            // 备注列表
            getStuRemarkRecordListFunc() {
                getStuRemarkRecordList({
                    stuId: this.stuId,
                })
                    .then(res => res.data)
                    .then(data => {
                        if (data.result) {
                            this.commentList = data.data;
                        }
                    })
            },
            // 删除备注
            deleteComment(commentId) {
                this.$confirm('是否删除该备注?', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delStuRemarkById({
                        stuRemarkId: commentId
                    })
                        .then(res => res.data)
                        .then(data => {
                            if (data.result) {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功！'
                                });
                                this.getStuRemarkRecordListFunc();
                            } else {
                                this.$message.error(data.msg);
                            }
                        })
                });
            },
            // 备注
            comment() {
                this.$refs.commentForm.validate((valid) => {
                    if (valid) {
                        addStuRemarkRecord({
                            noticeId: this.noticeId,
                            stuId: this.stuId,
                            remark: this.commentQuery.remark
                        })
                            .then(res => res.data)
                            .then(data => {
                                if (data.result) {
                                    this.$message({
                                        type: 'success',
                                        message: '备注成功！'
                                    });
                                    this.getStuRemarkRecordListFunc();
                                    this.commentQuery.remark = '';
                                    this.commentVisibility = false;
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                    }
                });
            },
            //线下二审
            examHandler() {
                this.listQuery.isApprove = 1;
                this.isShowNotApprove = false;
                if (this.fieldNameList.indexOf('isProperty') !== -1) {
                    this.listQuery.isProperty = 1;
                }
                if (this.fieldNameList.indexOf('isRealLive') !== -1) {
                    this.listQuery.isRealLive = 1;
                }
                if (this.fieldNameList.indexOf('isTeachArea') !== -1) {
                    this.listQuery.isTeachArea = 1;
                }
                if (this.fieldNameList.indexOf('isTeachAreaNotice') !== -1) {
                    this.listQuery.isTeachAreaNotice = 1;
                }
                if (this.fieldNameList.indexOf('isLocalRegister') !== -1) {
                    this.listQuery.isLocalRegister = 1;
                }
                if (this.fieldNameList.indexOf('isVisit') !== -1) {
                    this.listQuery.isVisit = 1;
                }
                this.examVisibletow = true;
            },
            addTimeHandlers() {
                this.$refs.examObject.validate((valid) => {
                    if (valid) {
                        this.examVisibletow = false;
                        if (this.fieldNameList.indexOf('isProperty') == -1) {
                            this.listQuery.isProperty = 2;
                        }
                        if (this.fieldNameList.indexOf('isRealLive') == -1) {
                            this.listQuery.isRealLive = 2;
                        }
                        if (this.fieldNameList.indexOf('isTeachArea') == -1) {
                            this.listQuery.isTeachArea = 2;
                        }
                        if (this.fieldNameList.indexOf('isTeachAreaNotice') == -1) {
                            this.listQuery.isTeachAreaNotice = 2;
                        }
                        if (this.fieldNameList.indexOf('isLocalRegister') == -1) {
                            this.listQuery.isLocalRegister = 2;
                        }
                        if (this.fieldNameList.indexOf('isVisit') == -1) {
                            this.listQuery.isVisit = 2;
                        }
                        finalExamineStudent({
                            id: this.listQuery.id,
                            finalState: this.listQuery.isApprove === 1 ? 1 : this.listQuery.notApproveReason,
                            isProperty: this.listQuery.isProperty,
                            isRealLive: this.listQuery.isRealLive,
                            isTeachArea: this.listQuery.isTeachArea,
                            isTeachAreaNotice: this.listQuery.isTeachAreaNotice,
                            isLocalRegister: this.listQuery.isLocalRegister,
                            isVisit: this.listQuery.isVisit,
                            examineRemark: this.listQuery.examineRemark
                        }).then(res => res.data)
                            .then(data => {
                                if (data.code === 200) {
                                    this.$message({
                                        type: 'success',
                                        message: '线下二审完成！'
                                    });
                                    //线下一审
                                    getStuOfflineOneExamineRecordList(this.$route.query.stuId).then(res => res.data)
                                        .then(data => {
                                            this.onelist = data.data

                                        });
                                    //线下二审
                                    getStuOfflineTwoExamineRecordList(this.$route.query.stuId).then(res => res.data)
                                        .then(data => {
                                            this.twolist = data.data
                                        });
                                }
                            })
                    }
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../styles/mixin";

    @include globalstyle;
    /*===================== global resetting ============*/

    /*=============== base ==================*/
    body {
        background-color: #5D5D5D;

    }

    .notify {
        border-top: 1px solid #333;
        border-bottom: 1px solid #333;
        color: #ff0000;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .global-container {
        background-color: #fff;
        overflow-x: hidden;
        overflow-y: auto;
    }

    .icon {
        width: 30px;
        height: 30px;
        display: inline-block;
        vertical-align: middle;
        background: no-repeat center center / cover;
    }

    .icon--record {
        background-image: url(../../../assets/images/primary/icon-record2.png);
        position: relative;
        top: -2px;
        margin-right: 10px;
    }

    .icon--score {
        background-image: url(../../../assets/images/primary/icon-score.png);
        position: relative;
        top: -2px;
        margin-right: 10px;
    }

    .icon--honor {
        background-image: url(../../../assets/images/primary/icon-honor.png);
        position: relative;
        top: -2px;
        height: 26px;
        width: 26px;
        margin-right: 10px;
    }

    .icon--duty {
        background-image: url(../../../assets/images/primary/icon-duty.png);
        position: relative;
        top: -2px;
        height: 24px;
        width: 24px;
        margin-right: 10px;
    }

    .icon--prize {
        background-image: url(../../../assets/images/primary/icon-prize.png);
        position: relative;
        top: -2px;
        height: 24px;
        width: 24px;
        margin-right: 10px;
    }

    .icon--sport {
        background-image: url(../../../assets/images/primary/icon-sport.png);
        position: relative;
        top: -2px;
        height: 24px;
        width: 24px;
        margin-right: 10px;
    }

    /*=============== studentInfo =============*/
    .header {
        height: 54px;
        box-sizing: border-box;
        border-top: 10px solid #22A98B;
        color: #7B7B7B;
        line-height: 44px;
        padding-left: 16px;
    }

    .section-header {
        position: relative;
        height: 40px;
        line-height: 40px;
        font-size: 20px;
        /*color: rgb(64, 158, 255);*/
        font-weight: bold;
    }

    .section-header__bottom-block {
        position: absolute;
        box-sizing: border-box;
        width: 380px;
        color: #fff;
        background: linear-gradient(to right, rgba(64, 158, 255, 1), rgba(64, 158, 255, 0.1));
        height: 8px;
        font-size: 20px;
    }

    .section-body {
        padding: 20px 0 10px 0;
        clear: both;
    }

    .section-body:after {
        visibility: hidden;
        display: block;
        font-size: 0;
        content: " ";
        clear: both;
        height: 0;
    }

    .section-body__left-block {
        float: left;
    }

    .section-body__right-block {
        float: left;
        margin-left: 10px;
    }

    .section--general-info .section-body__left-block {
        width: 30%;
    }

    .section--general-info .section-body__right-block {
        width: 500px;
    }

    .student-photo {
        width: 180px;
        margin: 0 auto;
        background: no-repeat center center / cover;
    }

    .student-name {
        font-size: 34px;
        width: 324px;
        text-align: center;
        margin-bottom: 20px;
    }


    .student-info-item__label, .student-info-item__value {
        display: inline-block;
        font-size: 18px;
    }

    .student-info-item__label {
        vertical-align: top;
        width: 170px;
        margin-right: 15px;
        text-align: right;
    }

    .student-info-item__value {
        width: 310px;
        color: #777;
    }

    .info-item {
        margin-bottom: 10px;

        &.info-item--wide {
            width: 100% !important;
            clear: both;
        }
    }

    .notify {
        color: #ff0000;
    }

    .info-item > * {
        display: inline-block;
        vertical-align: middle;
        font-size: 16px;
    }

    .info-item__label {
        color: #409EFF;
        width: 20%;
        margin-right: 30px;
        text-align: right;
    }

    .info-item__value {
        width: 58%;
        color: #464A4B;
    }

    .section--address-info .info-item__label {
        vertical-align: top;
    }

    .parent-info-container:first-child {
        float: left;

    }

    .section-body--parent {
        padding: 20px 30px 0 30px;

        .info-item__label {
            margin-right: 10px;
            width: 32%;
        }

        .info-item__value {
            width: 58%;
        }
    }

    .parent-info-container {
        width: 49%;
        float: left;
        box-sizing: border-box;
    }

    .info-item__value > * {
        display: block;
        word-break: break-all;
    }

    .sub-info {
        font-size: 12px;
    }

    .image-container {
        width: 40px;
        height: 40px;
        background: no-repeat center center / cover;
        float: left;
        margin: 0 5px 5px 0;
    }

    .section--verify-info .info-item__label {
        width: 200px;
        margin-right: 50px;
        vertical-align: top;
        color: #464A4B;
    }

    .section--verify-info .info-item__value {
        width: 550px;
    }

    .section--verify-info .info-item__label span {
        width: 90px;
        display: inline-block;
    }

    .personal-info__title {
        margin-bottom: 10px;
        color: #409EFF;
        font-size: 18px;
    }

    .personal-info__item > * {
        display: inline-block;
    }

    .personal-info__item-label {
        margin-bottom: 10px;
        color: #409EFF;
        width: 120px;
        margin-right: 30px;
    }

    .personal-info__item-value {
        width: 540px;
        color: #464A4B;
    }

    .score-item, .honor-item, .duty-item {
        margin-right: 20px;
    }

    .score-item > * {
        margin-right: 7px;
    }

    .line-container {
        clear: both;
        padding: 0 20px;
        @include clearfix;
    }

    .pic-container {
        padding: 5px 0;
        width: 49%;
        box-sizing: border-box;
        float: left;

        .info-item__label {
            text-align: left;
        }

        .pic {
            margin-left: 10px;
            display: inline-block;
            vertical-align: top;
        }

        .info-item__label {
            display: inline-block;
            width: 12em;
        }
    }

    .pic-item {
        width: 80px;
        height: 80px;
        background: no-repeat center center / cover;
        display: inline-block;
        margin: 0 10px 10px 0;
    }

    .section {
        clear: both;
    }

    .section--character-card .sub-section {
        border-top: 1px solid #23A68B;
        margin: 0 auto;
        width: 750px;
        box-sizing: border-box;
        padding: 0 25px;
    }

    .personal-info-entry {
        font-size: 16px;
        margin-top: 30px;
    }

    .personal-info-section:first-child {
        border: 0;
    }

    .personal-info-section > *:first-child {
        margin-top: 0;
    }

    .personal-info__bottom-line, .sub-section-item__bottom-line {
        width: 40%;
        height: 5px;
        background-color: #23A68B;
    }

    .personal-info-entry:last-child .personal-info__bottom-line {
        display: none;
    }

    .sub-section-item:last-child .sub-section-item__bottom-line {
        display: none;
    }

    /*=============== 专长==========*/
    .sub-section__title {
        margin-bottom: 10px;
        color: #409EFF;
        padding-top: 30px;
        font-size: 18px;
    }

    .sub-section-item {
        font-size: 16px;
        margin-bottom: 10px;
        position: relative;
    }

    .sub-section-item .sub-section-item__pic-container {
        padding: 10px 0;
    }

    .sub-section-item > span {
        margin: 0 5px;
        color: #9E9E9E;
    }

    .sub-section-item .sub-section-item__name {
        display: inline-block;
        min-width: 60px;
        font-weight: bold;
        margin-right: 20px;
        color: #333;
    }

    #print_div {
        display: none;
    }

    .printRemindMsg {
        display: none;
    }

    .remindMsg {
        display: block;
    }

    .print-only {
        display: none !important;
    }

    @media print {
        #content {
            width: 900px !important;
        }
        #content * {
            color: #000 !important;
        }
        .content {
            border: 0 !important;
        }
        .section-header__bottom-block {
            width: 250px !important;
        }
        .notify--not-print {
            display: none !important;
        }
        #print_div {
            display: block;
        }
        .header {
            font-size: 34px !important;
        }
        .section--verify-info .info-item__label span {
            width: 80px !important;
        }
        * {
            -webkit-print-color-adjust: exact;
        }
        .section-header__bottom-block {
            background-color: #409EFF !important;
            color: #fff !important;
        }
        .sub-section__title {
        }
        .icon {
            width: 30px !important;
            height: 30px !important;
            display: inline-block !important;
            vertical-align: middle !important;
            background: no-repeat center center / cover !important;
        }
        .icon--record {
            background-image: url(../../../assets/images/primary/icon-record2.png) !important;
        }
        .icon--score {
            background-image: url(../../../assets/images/primary/icon-score.png) !important;
        }
        .icon--honor {
            background-image: url(../../../assets/images/primary/icon-honor.png) !important;
        }
        .icon--duty {
            background-image: url(../../../assets/images/primary/icon-duty.png) !important;
        }
        .icon--prize {
            background-image: url(../../../assets/images/primary/icon-prize.png) !important;
        }
        .icon--sport {
            background-image: url(../../../assets/images/primary/icon-sport.png) !important;
        }

        #print_div .section-body__right-block {
            width: 500px !important;
        }
        #print_div .section-body__right-block .student-info-item__value {
            width: 310px !important;
        }
        #print_div .info-item__value {
            width: 560px !important;
        }
        #print_div .student-info-item__label, #print_div .student-info-item__value {
            font-size: 20px;
        }
        #print_div .info-item > * {
            font-size: 20px;
        }

        .printRemindMsg {
            display: block;
        }
        .remindMsg {
            display: none;
        }
        .noprint {
            display: none !important;
        }
        .print-only {
            display: block !important;

            &.print-only--inline-block {
                display: inline-block !important;
            }
        }
        .printToleft {
            float: left !important;
        }
    }

    .second-header-wrap {
        left: 0;
        width: 68%;
        height: 60px;
        line-height: 60px;
        padding: 5px 0;
        background-color: #fff;
        z-index: 1000;
    }

    .content {
        width: 68%;
        float: left;
        border-right: 1px solid #eee;
    }

    .review-list-section {
        float: left;
        width: 29%;
        margin-left: 2%;
        box-sizing: border-box;

    }

    .review-list-container {
        box-sizing: border-box;
        width: 100%;
        border: 1px #ddd solid;
        margin-bottom: 10px;
        padding: 0 20px 0px 20px;
        border-radius: 5px;
    }

    .review-list--live {
        .review-item {
            .review-item__detail {
                float: left;
                width: 62%;
                margin-left: 8%;
            }

            .review-item__remark {
                word-break: break-all;
            }

            .review-item__info {
                font-size: 14px;
                text-align: right;
            }

            .review-item__user {
                text-align: right;
                font-size: 14px;
                color: #333;
            }
        }
    }


    .review-item {
        @include clearfix;
        margin-bottom: 10px;
        padding: 5px;
        border-top: 1px solid #ddd;

        .review-item__state {
            float: left;
            width: 30%;
        }

        .review-item__detail {
            float: left;
            width: 70%;

            div {
                overflow: hidden;
                word-break: break-all;
                text-overflow: ellipsis;
            }
        }

        .review-item__user {
            text-align: right;
            font-size: 14px;
            color: #333;
        }
    }

    .review-list-container--comment {
        .review-item__detail {
            width: 100%;
        }
    }

    .print-header {
        font-size: 26px;
        text-align: center;
        font-weight: bold;
        position: relative;

        .print-header__recruit-no {
            position: absolute;
            left: 0;
        }

        .print-header__status {
            position: absolute;
            right: 0;
        }
    }

    .print-header--sub {
        font-size: 18px;
        color: #999;
    }

    .comment-info {
        @include middleIB;
    }

    .delete-comment-btn {
        @include middleIB;
        margin-left: 5px;
        height: 17px;
        color: #f08080;
        cursor: pointer;
    }

    .info-item--confirm {
        color: #f08080;
    }

    .section--address-info {
        .section-body {
            padding: 20px 30px 0 30px;
        }

        .info-item {
            float: left;
            width: 49%;
            box-sizing: border-box;

            .info-item__label {
                width: 32%;
                margin-right: 10px;
            }
        }
    }

    .photo-fill.section-body__left-block {
        width: 3.5cm;
        height: 4.9cm;
        border: 1px dashed #333;
        margin-left: 50px;
        margin-top: 30px;
        line-height: 4.9cm;
        text-align: center;
    }
</style>
<style lang="scss">
    #questionnaire {
        .address-box-item {
            line-height: 36px;
        }

        .el-checkbox, .el-checkbox__input {
            white-space: normal !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/primary/review/ReviewQuestionnaireDetail.vue